import { Request } from "../../request";

export const driversApp = (url) => {
  Request.get(url);
};
